import * as V1 from './standard-report'
// import * as V2_Original from './standard-reportV2' // If valid V2 exists and is different
import * as V2 from './standard-reportV2_2'

// Centralized Version Registry
const reportVersions = {
    1: V1,
    2: V2,
    // Future versions can be added easily:
    // 3: V3
}

/**
 * Retrieves the full data set for a given report version.
 * @param {string|number} version - The version identifier (e.g., 1, 2)
 * @returns {object} The data module for the requested version
 */
export const getReportData = (version) => {
    return reportVersions[version] || reportVersions[2]; // Default to V2
}

/**
 * Returns a list of available versions.
 * @returns {string[]} Array of available version keys
 */
export const getAvailableVersions = () => Object.keys(reportVersions);
